export const tinyMCEPlugins = 'link image lists paste';
export const tinyMCEToolbar =
    'p h1 h2 h3 h4 h5 h6 | bullist numlist | bold italic underline strikethrough | link image';
export const tinyMCEFormats = {
    underline: { inline: 'span', styles: { textDecoration: 'underline' } },
    strikethrough: { inline: 'del', styles: { textDecoration: 'strikethrough' } },
};
